export default __webpack_public_path__ + "static/media/who_we_are.77fd47b3.png";